import {
  COMPLETE_ACCOUNT_FORM,
  EMAIL_FORM,
  PASSWORD_FORM,
  PRIVATE_NOTICE,
  SELECT_USER_FORM,
  SIGN_UP_FORM,
} from "%/dynamic-component-editor/constants/login-flow-constants";

export function resolveInitialFlowStep({
  loginWithInspirationRequestId = 0,
  userId = 0,
  lastLoggedInUsers = {},
  userAuthEmail = "",
} = {}) {
  if (!loginWithInspirationRequestId) {
    return userAuthEmail ? COMPLETE_ACCOUNT_FORM : EMAIL_FORM;
  }
  if (userId > 0 || Object.keys(lastLoggedInUsers ?? {}).length > 0) {
    return SELECT_USER_FORM;
  }
  return EMAIL_FORM;
}

export const DELETED_ACCOUNT_SIGN_UP_NOTE = "The account for this email was deleted. You can create a new one.";

export function resolveStepAfterEmailCheck({ exists, canSignUp }) {
  if (exists) {
    return PASSWORD_FORM;
  }
  return canSignUp ? SIGN_UP_FORM : PRIVATE_NOTICE;
}

export function resolveEmailCheckOutcome({ exists, deleted = false, canSignUp }) {
  const step = resolveStepAfterEmailCheck({ exists: exists && !deleted, canSignUp });
  const signUpNote = deleted && step === SIGN_UP_FORM ? DELETED_ACCOUNT_SIGN_UP_NOTE : "";
  return { step, signUpNote };
}

export function resolveSignUpDestination({
  requirePaidSubscription = false,
  redirect = "",
  fanUrl = "",
  hostname = "",
} = {}) {
  if (requirePaidSubscription) {
    const subscribeUrl = `${fanUrl}/subscribe`;
    return redirect
      ? `${subscribeUrl}?redirect=${encodeURIComponent(redirect)}`
      : subscribeUrl;
  }

  if (!redirect) {
    return fanUrl;
  }

  return redirect.startsWith("http") ? redirect : `https://${hostname}${redirect}`;
}
